module.exports = __webpack_public_path__ + "static/media/warning-buzzer.6ef2795f.mp3";